import { useStandardProduct } from "app/hooks/shared/standard-product/useStandardProduct";
import React, { memo, useCallback, useMemo } from "react";
import {
  CategoryStandardProduct,
  StandardProductCategory,
} from "shared/api/middleware-api-client";
import { StandardProductsProduct } from "./StandardProductsProduct";
import Text from "../../../../shared/ui/typography/Text";
import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";

interface ListProps {
  selectedCategory: StandardProductCategory | undefined;
}

export const StandardProductsProductList = memo(
  ({ selectedCategory }: ListProps) => {
    const { store, actions } = useStandardProduct();
    const { onStandardProductConfig } = useAnalytics();

    const selectedProduct = useMemo(
      () => store.selectedStandardProduct,
      [store.selectedStandardProduct],
    );
    const selectProduct = useCallback(
      (product: CategoryStandardProduct) => {
        const updatedProduct = {
          ...product,
          amount: 1,
        };
        actions.selectStandardProduct(updatedProduct);
        onStandardProductConfig(updatedProduct);
      },
      [actions],
    );

    return (
      // Items
      <div className="gg-flex gg-flex-wrap gg-items-start gg-justify-evenly gg-gap-[1.8rem] gg-pt-4 sm:gg-justify-start">
        {selectedCategory?.product.map((categoryProduct) => {
          const isOptionActive =
            selectedProduct?.id === categoryProduct.standardProduct.id;

          return (
            <StandardProductsProduct
              key={categoryProduct.id}
              categoryProduct={categoryProduct}
              selectProduct={selectProduct}
              isOptionActive={isOptionActive}
            />
          );
        })}

        {selectedProduct && (
          <div className="gg-w-full gg-bg-grey-500 gg-p-4 gg-text-sm gg-text-dark-blue">
            <header className="gg-mb-2 gg-flex gg-justify-between">
              <Text className="gg-font-bold">
                Huidige keuze: {selectedProduct.name}
              </Text>
            </header>
            <Text>{selectedProduct.description}</Text>
          </div>
        )}
      </div>
    );
  },
);
